<nav class="navigation">
    <ng-container *ngFor="let link of links">
        <a
            *ngIf="!link.hidden"
            class="menu-link"
            [ngClass]="{ 'non-link': link.action, 'active-action': link.isActiveAction }"
            [routerLink]="link.url"
            routerLinkActive="active"
            [queryParams]="link.queryParams"
            (click)="doAction($event, link)"
        >
            <span *ngIf="link.icon" class="section-icon fa" [ngClass]="link.icon"></span>
            <span class="cm-link">{{ link.name }}</span> <span class="fa fa-angle-right"></span>
        </a>
    </ng-container>
</nav>
